module.exports = ".default {\n  background: #ddd !important; }\n\n.default:hover {\n  background: #cecece !important; }\n\n.scroll-v {\n  max-height: 80vh;\n  overflow-y: auto !important;\n  overflow-x: auto !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/creation-dynamic-component/creation-dynamic-component.component.scss
// module id = ./src/app/administration/creation-dynamic-component/creation-dynamic-component.component.scss
// module chunks = main